<template>
    <router-view class="full-height"></router-view>
</template>

<script>
    export default {
        name: 'CommandView',
        components: {
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
</style>
